import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import '@fontsource-variable/archivo/wdth.css';
import ScrollToTop from './components/ScrollToTop';
import Header from './components/Header';
import Footer from './components/Footer';
import Portal from './components/site/Portal';
import { useLenis } from './components/home/v3/motion';
import Home from './pages/Home';
import NossoTrabalho from './pages/nossoTrabalho';
import PsicoID from './pages/PsicoID';
import Revyou from './pages/Revyou';
import EgTreinos from './pages/EgTreinos';
import MeuAtalho from './pages/MeuAtalho';
import MeuAtalhoLegal from './pages/MeuAtalhoLegal';
import Sobre from './pages/Sobre';
import Contato from './pages/Contato';
import PoliticaPrivacidade from './pages/PoliticaPrivacidade';
import NotFound from './pages/NotFound';
import './App.css';

// Scroll suave em todas as páginas (desligado com reduced-motion).
function SmoothScroll() {
  useLenis();
  return null;
}

function App() {
  return (
    <Router>
      <SmoothScroll />
      <ScrollToTop />
      {/* Sentinela do topo: o header ganha fundo quando ela sai da tela */}
      <span id="page-top" className="page-top-sentinel" aria-hidden />
      <a href="#conteudo" className="skip-link" data-no-portal="">
        Pular para o conteúdo
      </a>
      <Header />
      <div id="conteudo" tabIndex={-1} className="page-root">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/nosso-trabalho" element={<NossoTrabalho />} />
          <Route path="/apps/psicoid" element={<PsicoID />} />
          <Route path="/apps/revyou" element={<Revyou />} />
          <Route path="/apps/eg-treinos" element={<EgTreinos />} />
          <Route path="/apps/meu-atalho" element={<MeuAtalho />} />
          <Route path="/apps/meu-atalho/:documentSlug" element={<MeuAtalhoLegal />} />
          <Route path="/sobre" element={<Sobre />} />
          <Route path="/contato" element={<Contato />} />
          <Route path="/politica-privacidade" element={<PoliticaPrivacidade />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </div>
      <Footer />
      <Portal />
    </Router>
  );
}

export default App;
